// extracted by mini-css-extract-plugin
module.exports = {"customer_rating":"customer-rating_customer_rating__zHsP5","container__customer_rating":"customer-rating_container__customer_rating__o1cWi"};